export default __webpack_public_path__ + "aaca23354f417f61323c375d3157adde.png";